import React from 'react';
import PropTypes from 'prop-types';

import styles from './grey-box.css';

const GreyBox = (props) => {
    const { children, modifier } = props;
    const classList = `${styles.wrapper}
                        ${modifier || ''}`;

    return (
        <div className={classList}>
            {children}
        </div>
    );
};

GreyBox.propTypes = {
    modifiers: PropTypes.string,
    children: PropTypes.node
};

export default GreyBox;
